module.exports = __webpack_public_path__ + "static/media/iiith.854c917a.png";